import type { WidgetDataContract } from "@nexus/widget-sdk";

/**
 * `protection-overview-tenant-campaigns` v1 — one tenant's top campaigns for
 * one published Protection Overview report edition.
 *
 * A tenant with no campaigns in this edition still gets a row, with an empty
 * `campaigns` list — the widget shows an explicit empty state rather than
 * treating it as an error.
 */
export const PROTECTION_OVERVIEW_CAMPAIGNS_CONTRACT: WidgetDataContract = {
  name: "protection-overview-tenant-campaigns",
  version: 1,
};

export interface ProtectionOverviewCampaignTenant {
  id: number;
  label: string;
  region: string;
}

export interface ProtectionOverviewCampaignEntry {
  id: string;
  label: string;
  start: string;
  end: string;
  avgIntegrity: number;
  eventCount: number;
  hasReport: boolean;
}

export interface ProtectionOverviewCampaignsFreshness {
  generatedAt: string;
  dataThrough: string;
  /** "demo", "clickhouse", or a named upstream feed. */
  source: string;
  isEstimated: boolean;
}

export interface ProtectionOverviewCampaignsData {
  tenant: ProtectionOverviewCampaignTenant;
  campaigns: ProtectionOverviewCampaignEntry[];
  freshness: ProtectionOverviewCampaignsFreshness;
}
